import React from 'react'
import { BrowserRouter as Router, Switch, useRouteMatch } from 'react-router-dom'
import EpicMenu from '../../componentes/Menus/EpicMenu';
import Menu from '../../componentes/Menus/Productos';
import Inventory from './Inventario/Inventario'
import Compras from './Compra/Compra'
import Movimientos from './Movimientos/Movimientos'
import Catalogos from './Registro/Registro'
import Aplicaciones from './Aplicaciones/index'
import PrivateRoute from '../../PrivateRoute'
import OrdenCompra from './OrdenCompra'
//import '../../componentes/Menus//Menu.css';

const InventoryRoutes = () => {
    let { path, url } = useRouteMatch()
    console.log(url)
    return (
    <>
    <div className='header'>
        <EpicMenu />
        <div className='inline'>Productos</div>
    </div>
    <Router>
    <div className='body'>
        <Menu url={url} />
        <section>
            <Switch>
                <PrivateRoute roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']} exact 
                    path={path} component={Inventory} />
                <PrivateRoute roles={['productPurchase']} 
                    path={`${path}/Compras`} component={Compras} />
                <PrivateRoute roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']} 
                    path={`${path}/OrdenCompra`} component={OrdenCompra} />
                <PrivateRoute roles={['warehouseAdmin', 'warehouse']} 
                    path={`${path}/Aplicaciones`} component={Aplicaciones} />
                <PrivateRoute roles={['productPurchase']} 
                    path={`${path}/Movimientos`} component={Movimientos} />
                <PrivateRoute roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']} 
                    path={`${path}/Catalogos`} component={Catalogos} />
            </Switch>
        </section>
    </div>
    <div className="footer" >
        <div className="footer1" >
        </div>
        <div className="footer2" ></div>
    </div>
    </Router>
    </>
    )
}

export default InventoryRoutes